export default __webpack_public_path__ + "static/media/Dwigt Rortugal.c73880a2.jpg";